import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import fflogo from '../Assets/fflogo.png';
import { NavLink } from 'react-router-dom';  // Import NavLink instead of Link

function CollapsibleNavbar() {
  return (
    <Navbar collapseOnSelect expand="lg" className="bg-body-tertiary custom-navbar nav-height">
      <Container>
        <Navbar.Brand href="/" style={{ flex: 1 }}>
          <img src={fflogo} style={{ width: '200px' }} alt='Forward Focus Logo in colors' />
        </Navbar.Brand>
      
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="ms-auto nav-link-spacing links">
            <Nav.Link 
              as={NavLink} 
              to="/" 
              exact
              style={{ fontSize: '90%', marginRight: '1rem' }}
              className='navigation-link'
              activeClassName="active-link" // When active, this class is added
            >
              HOME
            </Nav.Link>
            <Nav.Link 
              as={NavLink} 
              to="/meetings" 
              style={{ fontSize: '90%', marginRight: '1rem' }}
              className='navigation-link'
              activeClassName="active-link"
            >
             MEETINGS
            </Nav.Link>
    <Nav.Link 
              as={NavLink} 
              to="/issues" 
              style={{ fontSize: '90%', marginRight: '1rem' }}
              className='navigation-link'
              activeClassName="active-link"
            >
    KEY ISSUES
            </Nav.Link>    
            <Nav.Link 
              as={NavLink} 
              to="/newsletters" 
              style={{ fontSize: '90%', marginRight: '1rem' }}
              className='navigation-link'
              activeClassName="active-link"
            >
            NEWSLETTERS
            </Nav.Link> 
            <Nav.Link 
              as={NavLink} 
              to="/maps" 
              style={{ fontSize: '90%', marginRight: '1rem' }}
              className='navigation-link'
              activeClassName="active-link"
            >
            MAPS
            </Nav.Link>
       <Nav.Link 
              as={NavLink} 
              to="/comments" 
              style={{ fontSize: '90%', marginRight: '1rem' }}
              className='navigation-link'
              activeClassName="active-link"
            >
           PUBLIC COMMENTS
            </Nav.Link> 
            
            <Nav.Link 
              as={NavLink} 
              to="/contact" 
              style={{ fontSize: '90%', marginRight: '1rem' }}
              className='navigation-link'
              activeClassName="active-link"
            >
              CONTACT US
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default CollapsibleNavbar;
